// import { createStore } from 'redux';
// import { myReducer } from '../reducers';

// export const myStore = createStore(
//     myReducer,
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );


// src/store.js
import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import reduxStorage from 'redux-persist/lib/storage'; // defaults to localStorage
import { myReducer } from '../reducers'; // Update the path as necessary

const persistConfig = {
  key: 'root',
  storage: reduxStorage,
  whitelist: ['user'], // Only persist the user reducer
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, myReducer);

// Create the Redux store
export const myStore= createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // Optional: for Redux DevTools
);

// Create the persistor
export const persistor = persistStore(myStore);
